module.exports = __webpack_public_path__ + "static/georges-marvelous-medicine-8154854c38b4be9fd81a8696e9f271ac.jpg";